export const stripePkKey = process.env.STRIPE_PK_KEY || 'pk_live_YIIPo7udwp9CLUPJgf2djXVO00uW7LQfnQ';
// export const stripePkKey = process.env.STRIPE_PK_KEY || 'pk_test_RT6HR2L7f8C8kx0B01mY5yWS00rSmuYHH7';